// Textos da Lavoura da Farm (02/11/2026), coletados por glob em core/i18n/messages.ts.
export default {
  pt: {
    'farm.lavoura.escolherSafra': 'Escolher a safra',
    'farm.lavoura.escolherImovel': 'Escolher a fazenda',
    'farm.lavoura.safraAtual': 'Atual',
    'farm.lavoura.ha': '{{n}} ha',
    'farm.lavoura.scHa': '{{n}} sc/ha',
    'farm.lavoura.sacas': '{{n}} sc',
    'farm.lavoura.kpi.plantado': 'Plantado',
    'farm.lavoura.kpi.colhido': 'Colhido',
    'farm.lavoura.kpi.produtividade': 'Produtividade em {{cultura}}',
    'farm.lavoura.kpi.produtividadeMedia': 'Produtividade média',
    'farm.lavoura.kpi.semColheita': 'Sem colheita',
    'farm.lavoura.cliqueNaGleba': 'Clique num pivô ou talhão para lançar nele',
    'farm.lavoura.rapido.titulo': 'Lançamento rápido',
    'farm.lavoura.rapido.semGleba': 'Escolha a gleba no desenho ou na lista',
    'farm.lavoura.campo.gleba': 'Gleba',
    'farm.lavoura.campo.cultura': 'Cultura',
    'farm.lavoura.campo.operacao': 'Operação',
    'farm.lavoura.campo.data': 'Data',
    'farm.lavoura.campo.area': 'Área em ha',
    'farm.lavoura.campo.sacas': 'Sacas',
    'farm.lavoura.campo.produtividade': 'Sacas por ha',
    'farm.lavoura.campo.observacao': 'Observação',
    'farm.lavoura.glebaInteira': 'Gleba inteira',
    'farm.lavoura.frase': '{{operacao}} de {{cultura}} em {{gleba}}, {{quando}}',
    'farm.lavoura.hoje': 'hoje',
    'farm.lavoura.lancar': 'Lançar',
    'farm.lavoura.lancado': 'Lançamento gravado em {{gleba}}',
    'farm.lavoura.salvo': 'Lançamento salvo',
    'farm.lavoura.excluido': 'Lançamento excluído',
    'farm.lavoura.erro.gleba': 'Escolha a gleba',
    'farm.lavoura.erro.area': 'Informe a área',
    'farm.lavoura.operacao.plantio': 'Plantio',
    'farm.lavoura.operacao.colheita': 'Colheita',
    'farm.lavoura.operacao.aplicacao': 'Aplicação',
    'farm.lavoura.operacao.adubacao': 'Adubação',
    'farm.lavoura.col.gleba': 'Gleba',
    'farm.lavoura.col.operacao': 'Operação',
    'farm.lavoura.col.cultura': 'Cultura',
    'farm.lavoura.col.area': 'Área',
    'farm.lavoura.col.colheita': 'Colheita',
    'farm.lavoura.col.lancamento': 'Lançado por',
    'farm.lavoura.acoes': 'Ações',
    'farm.lavoura.filtro.cultura': 'Cultura',
    'farm.lavoura.filtro.operacao': 'Operação',
    'farm.lavoura.filtro.gleba': 'Gleba',
    'farm.lavoura.todas': 'Todas',
    'farm.lavoura.busca': 'Buscar gleba ou observação',
    'farm.lavoura.ajuda': 'Escolha a safra e a fazenda nos chips do alto. Clique num pivô ou talhão do desenho para lançar nele: a data vem com hoje e a área com a gleba inteira. Os cartões de cultura destacam a cultura no desenho e filtram a lista. Cada lançamento repinta a gleba na hora.',
    'farm.lavoura.excel': 'Excel',
    'farm.lavoura.editar': 'Editar',
    'farm.lavoura.excluir': 'Excluir',
    'farm.lavoura.historico': 'Histórico da gleba',
    'farm.lavoura.semResultado': 'Nada para mostrar com estes filtros.',
    'farm.lavoura.doTotal': 'de {{n}} ha',
    'farm.lavoura.editarTitulo': 'Editar lançamento',
    'farm.lavoura.excluirTitulo': 'Excluir o lançamento?',
    'farm.lavoura.excluirMensagem': '{{operacao}} de {{cultura}} em {{gleba}} no dia {{data}} sai da safra e do desenho.',
    'farm.lavoura.hist.titulo': 'Histórico de {{gleba}}',
    'farm.lavoura.hist.plantio': 'Plantio',
    'farm.lavoura.hist.colheita': 'Colheita',
    'farm.lavoura.hist.produtividade': 'Produtividade',
    'farm.lavoura.hist.semLancamento': 'Sem lançamento nesta safra',
    'farm.lavoura.hist.daPlanilha': 'Da planilha da fazenda',
    'farm.lavoura.hist.vazio': 'Sem histórico para esta gleba',
    'farm.lavoura.fechar': 'Fechar',
  },
  en: {
    'farm.lavoura.escolherSafra': 'Choose the season',
    'farm.lavoura.escolherImovel': 'Choose the farm',
    'farm.lavoura.safraAtual': 'Current',
    'farm.lavoura.ha': '{{n}} ha',
    'farm.lavoura.scHa': '{{n}} bags/ha',
    'farm.lavoura.sacas': '{{n}} bags',
    'farm.lavoura.kpi.plantado': 'Planted',
    'farm.lavoura.kpi.colhido': 'Harvested',
    'farm.lavoura.kpi.produtividade': 'Yield in {{cultura}}',
    'farm.lavoura.kpi.produtividadeMedia': 'Average yield',
    'farm.lavoura.kpi.semColheita': 'No harvest',
    'farm.lavoura.cliqueNaGleba': 'Click a pivot or plot to record on it',
    'farm.lavoura.rapido.titulo': 'Quick entry',
    'farm.lavoura.rapido.semGleba': 'Choose the plot on the drawing or on the list',
    'farm.lavoura.campo.gleba': 'Plot',
    'farm.lavoura.campo.cultura': 'Crop',
    'farm.lavoura.campo.operacao': 'Operation',
    'farm.lavoura.campo.data': 'Date',
    'farm.lavoura.campo.area': 'Area in ha',
    'farm.lavoura.campo.sacas': 'Bags',
    'farm.lavoura.campo.produtividade': 'Bags per ha',
    'farm.lavoura.campo.observacao': 'Note',
    'farm.lavoura.glebaInteira': 'Whole plot',
    'farm.lavoura.frase': '{{operacao}} of {{cultura}} on {{gleba}}, {{quando}}',
    'farm.lavoura.hoje': 'today',
    'farm.lavoura.lancar': 'Record',
    'farm.lavoura.lancado': 'Entry saved on {{gleba}}',
    'farm.lavoura.salvo': 'Entry saved',
    'farm.lavoura.excluido': 'Entry deleted',
    'farm.lavoura.erro.gleba': 'Choose the plot',
    'farm.lavoura.erro.area': 'Enter the area',
    'farm.lavoura.operacao.plantio': 'Planting',
    'farm.lavoura.operacao.colheita': 'Harvest',
    'farm.lavoura.operacao.aplicacao': 'Spraying',
    'farm.lavoura.operacao.adubacao': 'Fertilizing',
    'farm.lavoura.col.gleba': 'Plot',
    'farm.lavoura.col.operacao': 'Operation',
    'farm.lavoura.col.cultura': 'Crop',
    'farm.lavoura.col.area': 'Area',
    'farm.lavoura.col.colheita': 'Harvest',
    'farm.lavoura.col.lancamento': 'Recorded by',
    'farm.lavoura.acoes': 'Actions',
    'farm.lavoura.filtro.cultura': 'Crop',
    'farm.lavoura.filtro.operacao': 'Operation',
    'farm.lavoura.filtro.gleba': 'Plot',
    'farm.lavoura.todas': 'All',
    'farm.lavoura.busca': 'Search plot or note',
    'farm.lavoura.ajuda': 'Pick the season and the farm on the chips at the top. Click a pivot or plot on the drawing to record on it: the date starts as today and the area as the whole plot. The crop cards highlight the crop on the drawing and filter the list. Each entry repaints the plot right away.',
    'farm.lavoura.excel': 'Excel',
    'farm.lavoura.editar': 'Edit',
    'farm.lavoura.excluir': 'Delete',
    'farm.lavoura.historico': 'Plot history',
    'farm.lavoura.semResultado': 'Nothing to show with these filters.',
    'farm.lavoura.doTotal': 'of {{n}} ha',
    'farm.lavoura.editarTitulo': 'Edit entry',
    'farm.lavoura.excluirTitulo': 'Delete the entry?',
    'farm.lavoura.excluirMensagem': '{{operacao}} of {{cultura}} on {{gleba}} on {{data}} leaves the season and the drawing.',
    'farm.lavoura.hist.titulo': 'History of {{gleba}}',
    'farm.lavoura.hist.plantio': 'Planting',
    'farm.lavoura.hist.colheita': 'Harvest',
    'farm.lavoura.hist.produtividade': 'Yield',
    'farm.lavoura.hist.semLancamento': 'No entry in this season',
    'farm.lavoura.hist.daPlanilha': 'From the farm spreadsheet',
    'farm.lavoura.hist.vazio': 'No history for this plot',
    'farm.lavoura.fechar': 'Close',
  },
  es: {
    'farm.lavoura.escolherSafra': 'Elegir la zafra',
    'farm.lavoura.escolherImovel': 'Elegir la hacienda',
    'farm.lavoura.safraAtual': 'Actual',
    'farm.lavoura.ha': '{{n}} ha',
    'farm.lavoura.scHa': '{{n}} bolsas/ha',
    'farm.lavoura.sacas': '{{n}} bolsas',
    'farm.lavoura.kpi.plantado': 'Sembrado',
    'farm.lavoura.kpi.colhido': 'Cosechado',
    'farm.lavoura.kpi.produtividade': 'Rendimiento en {{cultura}}',
    'farm.lavoura.kpi.produtividadeMedia': 'Rendimiento medio',
    'farm.lavoura.kpi.semColheita': 'Sin cosecha',
    'farm.lavoura.cliqueNaGleba': 'Haga clic en un pivote o lote para registrar en él',
    'farm.lavoura.rapido.titulo': 'Registro rápido',
    'farm.lavoura.rapido.semGleba': 'Elija el lote en el dibujo o en la lista',
    'farm.lavoura.campo.gleba': 'Lote',
    'farm.lavoura.campo.cultura': 'Cultivo',
    'farm.lavoura.campo.operacao': 'Operación',
    'farm.lavoura.campo.data': 'Fecha',
    'farm.lavoura.campo.area': 'Área en ha',
    'farm.lavoura.campo.sacas': 'Bolsas',
    'farm.lavoura.campo.produtividade': 'Bolsas por ha',
    'farm.lavoura.campo.observacao': 'Observación',
    'farm.lavoura.glebaInteira': 'Lote entero',
    'farm.lavoura.frase': '{{operacao}} de {{cultura}} en {{gleba}}, {{quando}}',
    'farm.lavoura.hoje': 'hoy',
    'farm.lavoura.lancar': 'Registrar',
    'farm.lavoura.lancado': 'Registro guardado en {{gleba}}',
    'farm.lavoura.salvo': 'Registro guardado',
    'farm.lavoura.excluido': 'Registro eliminado',
    'farm.lavoura.erro.gleba': 'Elija el lote',
    'farm.lavoura.erro.area': 'Informe el área',
    'farm.lavoura.operacao.plantio': 'Siembra',
    'farm.lavoura.operacao.colheita': 'Cosecha',
    'farm.lavoura.operacao.aplicacao': 'Aplicación',
    'farm.lavoura.operacao.adubacao': 'Fertilización',
    'farm.lavoura.col.gleba': 'Lote',
    'farm.lavoura.col.operacao': 'Operación',
    'farm.lavoura.col.cultura': 'Cultivo',
    'farm.lavoura.col.area': 'Área',
    'farm.lavoura.col.colheita': 'Cosecha',
    'farm.lavoura.col.lancamento': 'Registrado por',
    'farm.lavoura.acoes': 'Acciones',
    'farm.lavoura.filtro.cultura': 'Cultivo',
    'farm.lavoura.filtro.operacao': 'Operación',
    'farm.lavoura.filtro.gleba': 'Lote',
    'farm.lavoura.todas': 'Todas',
    'farm.lavoura.busca': 'Buscar lote u observación',
    'farm.lavoura.ajuda': 'Elija la zafra y la hacienda en los chips de arriba. Haga clic en un pivote o lote del dibujo para registrar en él: la fecha viene con hoy y el área con el lote entero. Las tarjetas de cultivo destacan el cultivo en el dibujo y filtran la lista. Cada registro repinta el lote al instante.',
    'farm.lavoura.excel': 'Excel',
    'farm.lavoura.editar': 'Editar',
    'farm.lavoura.excluir': 'Eliminar',
    'farm.lavoura.historico': 'Historial del lote',
    'farm.lavoura.semResultado': 'Nada para mostrar con estos filtros.',
    'farm.lavoura.doTotal': 'de {{n}} ha',
    'farm.lavoura.editarTitulo': 'Editar registro',
    'farm.lavoura.excluirTitulo': '¿Eliminar el registro?',
    'farm.lavoura.excluirMensagem': '{{operacao}} de {{cultura}} en {{gleba}} el día {{data}} sale de la zafra y del dibujo.',
    'farm.lavoura.hist.titulo': 'Historial de {{gleba}}',
    'farm.lavoura.hist.plantio': 'Siembra',
    'farm.lavoura.hist.colheita': 'Cosecha',
    'farm.lavoura.hist.produtividade': 'Rendimiento',
    'farm.lavoura.hist.semLancamento': 'Sin registro en esta zafra',
    'farm.lavoura.hist.daPlanilha': 'De la planilla de la hacienda',
    'farm.lavoura.hist.vazio': 'Sin historial para este lote',
    'farm.lavoura.fechar': 'Cerrar',
  },
}
